import { PrimoboxEtatTraitement } from "../../dto/GenApi.iNotPaie.Dto/PrimoboxEtatTraitement";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";

export class primoboxHelper {
	// Convertit un état de traitement sous la forme enum en string
	public static convertPrimoboxEtatToString(etat: PrimoboxEtatTraitement): string {
		let value = "";
		switch (etat) {
			case PrimoboxEtatTraitement.NonDistribue:
				value = "Non distribué";
				break;
			case PrimoboxEtatTraitement.TraitementEnCours:
				value = "Traitement en cours";
				break;
			case PrimoboxEtatTraitement.TraitementTermineAvecAnomalies:
				value = "Anomalie détectée";
				break;
			case PrimoboxEtatTraitement.ValidationEnAttente:
				value = "En attente de validation";
				break;
			case PrimoboxEtatTraitement.DistributionEnCours:
				value = "Distribution en cours";
				break;
			case PrimoboxEtatTraitement.Termine:
				value = "Distribué";
				break;
			case PrimoboxEtatTraitement.Erreur:
				value = "Erreur";
				break;
			default:
				value = "État inconnu";
		}

		return value;
	}

	// Permet de savoir le style de texte à afficher pour les états
	public static canShowSimpleEtat(etat: PrimoboxEtatTraitement): boolean {
		return etat !== PrimoboxEtatTraitement.TraitementTermineAvecAnomalies && etat !== PrimoboxEtatTraitement.ValidationEnAttente && etat !== PrimoboxEtatTraitement.Erreur;
	}

	public static canShowAnomalieEtat(etat: PrimoboxEtatTraitement): boolean {
		return etat === PrimoboxEtatTraitement.TraitementTermineAvecAnomalies || etat === PrimoboxEtatTraitement.Erreur;
	}

	public static canShowValiderEtat(etat: PrimoboxEtatTraitement): boolean {
		return etat === PrimoboxEtatTraitement.ValidationEnAttente;
	}

	public static messageAnomalie(): void {
		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Une anomalie a été détectée dans Primobox.<br>Veuillez contacter le support afin de vérifier et corriger cette anomalie.",
			title: "ANOMALIE DÉTECTÉE"
		});
		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}
}



// WEBPACK FOOTER //
// ./src/components/Primobox/primoboxHelper.ts